/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

import env from './config/env';

const awsmobile = {
    Auth: {
        // REQUIRED - Amazon Cognito Region
        region: env.cognito.region,

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: env.cognito.userPool,

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: env.cognito.clientId,

        // OPTIONAL - Hosted UI configuration
        oauth: {
            domain: env.cognito.domain,
            // scope: ['phone', 'email', 'profile', 'openid'],
            redirectSignIn: env.cognito.redirectSignIn,
            redirectSignOut: env.cognito.redirectSignOut,
            responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
        }
    }

};


export default awsmobile;
